module.exports = __webpack_public_path__ + "img/mjjh1.d6d10438.jpg";